import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { DataSource } from '../types';

interface DataSourcesState {
  sources: DataSource[];
  syncInProgress: boolean;
  lastSyncTime: Date | null;
  dataQualityAlerts: Array<{
    id: string;
    sourceId: string;
    severity: 'HIGH' | 'MEDIUM' | 'LOW';
    message: string;
    timestamp: Date;
  }>;
}

const initialState: DataSourcesState = {
  sources: [],
  syncInProgress: false,
  lastSyncTime: null,
  dataQualityAlerts: [],
};

const dataSourcesSlice = createSlice({
  name: 'dataSources',
  initialState,
  reducers: {
    setSources: (state, action: PayloadAction<DataSource[]>) => {
      state.sources = action.payload;
    },
    updateSourceStatus: (state, action: PayloadAction<{ id: string; status: DataSource['status'] }>) => {
      const source = state.sources.find(s => s.id === action.payload.id);
      if (source) {
        source.status = action.payload.status;
        if (action.payload.status === 'CONNECTED') {
          source.lastSync = new Date();
        }
      }
    },
    setSyncInProgress: (state, action: PayloadAction<boolean>) => {
      state.syncInProgress = action.payload;
      if (!action.payload) {
        state.lastSyncTime = new Date();
      }
    },
    addDataQualityAlert: (state, action: PayloadAction<DataSourcesState['dataQualityAlerts'][0]>) => {
      state.dataQualityAlerts.unshift(action.payload);
      if (state.dataQualityAlerts.length > 10) {
        state.dataQualityAlerts = state.dataQualityAlerts.slice(0, 10);
      }
    },
    clearDataQualityAlerts: (state) => {
      state.dataQualityAlerts = [];
    },
  },
});

export const {
  setSources,
  updateSourceStatus,
  setSyncInProgress,
  addDataQualityAlert,
  clearDataQualityAlerts,
} = dataSourcesSlice.actions;

export default dataSourcesSlice.reducer;